import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { name: "CreateEditNotice" }
const _hoisted_2 = { class: "vstack gap-3" }

import {ref, computed, watch, onMounted} from "vue";
import {Death, DeathForm, DeathZeroReport, YearsQuartersAvailable} from "./schema";
import {useDcraStore} from "@/stores/dcraStore";
import FormModal from "../Misc/FormModal.vue";
import SelectField from "@/components/Misc/SelectField.vue";
import {BInput, BTextarea, BAgency, BDatePicker} from "@/components/Fields";
import {array, date, number, object, string, ValidationError} from "yup";
import {useFormValidation} from "@/validation";
import {SelectItem, UploadType, DatasetDetails} from "@/types";
import { BFilter, BFilterableField, dateTimeOperations } from "../BFilterEditor/BFilterEditor.types";

const title = "Add Zero Report";

//FUNctions


export default /*@__PURE__*/_defineComponent({
  __name: 'AddZeroReport',
  props: /*@__PURE__*/_mergeModels({
    startDate: {}
  }, {
    "modelValue": {type: Boolean},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["dismiss", "submit", "update:modelValue"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const modelValue = _useModel(__props, "modelValue");
const props = __props;
var agencyStartDate = ref(new Date(props.startDate));
const emit = __emit;
var dcraStore = useDcraStore();

const {handleSubmit, errors, resetValidation} = useFormValidation();

const form = ref({
    agency: "",
    year: new Date().getFullYear(),
    quarter: 0,
} as DeathZeroReport);

const schema = object<DeathForm>({
    agency: string().required("Agency is a required field"),
    year: number()
        .transform((value) => (Number.isNaN(value) ? null : value))
        .min(agencyStartDate.value.getFullYear())
        .max(new Date().getFullYear())
        .required("Year is a required field"),
    quarter: number().required("Quarter is a required field"),
});

var dcraErrors = ref([] as string[]);

var dcraOris = ref([] as SelectItem[]);
var quarters = ref([] as SelectItem[]);
var years = ref([] as SelectItem[]);
var yearsAndQuartersForSelectedAgency = ref([] as YearsQuartersAvailable[]);
const fetchYearsForDropdown = () => {
    years.value = [] as SelectItem[];
    yearsAndQuartersForSelectedAgency.value = [] as YearsQuartersAvailable[];

    const startYear = agencyStartDate.value.getFullYear();
    const endYear = new Date().getFullYear();

    for (let y = startYear; y <= endYear; y++) {
        yearsAndQuartersForSelectedAgency.value.push({
            yearLabel: `${y}`,
            yearValue: y,
            quarters: GenerateQuartersForYears(y)
        });
    }

    yearsAndQuartersForSelectedAgency.value.forEach((f: YearsQuartersAvailable) => {
        if (f.quarters.length > 0) {
            years.value.push({label: f.yearLabel, value: f.yearValue} as SelectItem);
        }
    });
}

const GenerateQuartersForYears = (year: number) => {
    const quarterArray = [] as SelectItem[];
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();

    const currentQuarterIndex = Math.floor(currentMonth / 3); // 0..3
    const startQuarterIndex = Math.floor(agencyStartDate.value.getMonth() / 3); // 0..3

    if (year === agencyStartDate.value.getFullYear()) {
        if (year === currentYear) {
            // agency started this year — include quarters from the start quarter
            // up to (but not including) the current quarter
            for (let i = startQuarterIndex; i < currentQuarterIndex; i++) {
                quarterArray.push({label: `Q${i + 1}`, value: i + 1} as SelectItem);
            }
        } else {
            for (let i = startQuarterIndex; i < 4; i++) {
                quarterArray.push({label: `Q${i + 1}`, value: i + 1} as SelectItem);
            }
        }
    } else if (year < currentYear) {
        quarterArray.push({label: "Q1", value: 1} as SelectItem, {label: "Q2", value: 2} as SelectItem, {label: "Q3", value: 3} as SelectItem, {label: "Q4", value: 4} as SelectItem);
    } else if (year === currentYear) {
        // include quarters strictly before the current quarter
        for (let i = 0; i < currentQuarterIndex; i++) {
            quarterArray.push({label: `Q${i + 1}`, value: i + 1} as SelectItem);
        }
    }

    return quarterArray;
};

const submitForm = async () => {
    if (await handleSubmit(schema, form.value)) {
        await dcraStore.addZeroReport(form.value);

        window.location.href = "dataupload.aspx?source=8";
    }
};

const handleYearUpdate = () => {

    form.value.quarter = -1;    

    const match = yearsAndQuartersForSelectedAgency.value.find((w:YearsQuartersAvailable) => w.yearValue === form.value.year);

    if (match) {
        quarters.value = match.quarters;
    }
}

const getOriList = async () => {
    let fields= [{property:"StartDate",operations:dateTimeOperations},
                 {property:"EndDate",operations:dateTimeOperations}   
    ] as BFilterableField[];

    const now = new Date();
    const firstDay = new Date(now.getFullYear(), Math.floor(now.getMonth() / 3) * 3, 1);
    
    let filters = [{property:"StartDate",operation:"lt",value:firstDay.toISOString().split('T')[0]}, 
                   {property:"EndDate",operation:"ge",value:now.toISOString().split('T')[0]}] as BFilter[];
    
    let data = await dcraStore.getOriListForDataset("DCRA", filters, fields);

    dcraOris.value = data.map(ori=> {
        return {label:`${ori.ori} - ${ori.label}`, value:ori.ori} as SelectItem;
    });
}



const handleAgencyChange = async () => {    
    
    form.value.year = -1;
    form.value.quarter = -1;
    
    let datasets = await dcraStore.fetchDatasetDetailsForOri(form.value.agency);
    let oriDetails= {} as DatasetDetails;

    datasets.forEach((ds: DatasetDetails) => {

            if (ds.name == "DCRA") {
                oriDetails = ds;
            }
        });

    if(oriDetails != undefined && oriDetails.agency_start_date){
        // Parse date string to avoid timezone shift issues
        const dateStr = typeof oriDetails.agency_start_date === 'string'
            ? oriDetails.agency_start_date.split('T')[0]
            : new Date(oriDetails.agency_start_date).toISOString().split('T')[0];
        const [year, month, day] = dateStr.split('-').map(Number);
        agencyStartDate.value = new Date(year, month - 1, day); // months are 0-indexed
    }

    fetchYearsForDropdown();
}

//LifeCycle Hooks
onMounted(async () => {
    await getOriList();
});

watch(
    () => form.value,
    async () => {
        
        try {
            if (errors.value.length == 0) {
                return;
            }

            errors.value = Array.isArray(errors.value) ? [] : {};
            await schema.validate(form.value, {abortEarly: false});
        } catch (err) {
            const error = err as ValidationError;
            if (error.name !== "ValidationError") throw err;

            // Build an object map of field -> message
            const newErrors: Record<string, string> = {};
            error.inner.forEach((it: ValidationError) => {
                if (it.path) newErrors[it.path] = it.message;
            });
            errors.value = newErrors;
        }
    },
    {deep: true}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(FormModal, {
      title: title,
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modelValue).value = $event)),
      "submit-button": 'Submit',
      onSubmit: submitForm
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "agency" }, "Agency *", -1)),
            _createVNode(SelectField, {
              name: "agency",
              class: "w-100",
              modelValue: form.value.agency,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((form.value.agency) = $event)),
                _cache[1] || (_cache[1] = ($event: any) => (handleAgencyChange()))
              ],
              "select-items": _unref(dcraOris),
              mode: "single",
              error: _unref(errors).agency,
              min: 1
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "year" }, "Year *", -1)),
            _createVNode(SelectField, {
              name: "year",
              class: "w-100",
              modelValue: form.value.year,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((form.value.year) = $event)),
                _cache[3] || (_cache[3] = ($event: any) => (handleYearUpdate()))
              ],
              "select-items": _unref(years),
              mode: "single",
              error: _unref(errors).year,
              min: 1
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "quarter" }, "Quarter *", -1)),
            _createVNode(SelectField, {
              name: "quarter",
              class: "w-100",
              modelValue: form.value.quarter,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.quarter) = $event)),
              "select-items": _unref(quarters),
              mode: "single",
              error: _unref(errors).quarter,
              min: 1,
              "open-direction": 'top'
            }, null, 8, ["modelValue", "select-items", "error"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})